import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const boxPlotTool: Tool = {
  id: "box-plot",
  name: () => m.box_tool_name(),
  description: () => m.box_tool_description(),
  icon: "📦",
  basePath: "/box-plot",
  status: "stable",
  tags: [
    "chart",
    "plot",
    "data-visualization",
    "box-plot",
    "statistics",
    "science",
  ],
};
